import React,{useMemo} from "react";
import { Link } from "react-router-dom";
import { useTable,useRowSelect } from 'react-table';
import axios from "axios";

import {AddOptionToString,IndeterminateCheckbox} from "../../../components/common/Common";

function FaqSearchResult({varColumnLists,varFaqLists,varTotalCount,ReadFaqLists}) {
  //컬럼 - 제목부
  const columns = useMemo(() => {
    if(varColumnLists?.length > 0) return varColumnLists; 
    // eslint-disable-next-line
  },[varColumnLists]);

  //표시할 정보
  const data = useMemo(() => {
    if(varFaqLists?.length > 0) return varFaqLists;
    // eslint-disable-next-line
  }, [varFaqLists]);

  //테이블 정보 설정 - 체크박스 포함
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow,selectedFlatRows} 
      = useTable({ columns, data, initialState:{hiddenColumns:["board_idx"]}},useRowSelect, 
        hooks => {
          hooks.visibleColumns.push(columns => [
            {
              id: 'selection',
              Header: ({ getToggleAllRowsSelectedProps }) => (
                <div style={{width:"30px"}}>
                  <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                </div>
              ),
              Cell: ({ row }) => (
                <div style={{width:"30px"}}>
                  <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
                </div>
              )
            },
            ...columns,
          ])
        }
  );

  const onDeleteFaqList = async(e) => {
    //console.log(selectedFlatRows,selectedRowIds);
    var iselected = selectedFlatRows.length;
    if(iselected === 0) {
      alert("삭제할 정보가 선택되어 있지 않습니다.");
      return false;
    }
    let boardIndexString = "";
    for(var i=0; i < iselected; i++) {
      var sline = selectedFlatRows[i].values['board_idx'];
      boardIndexString = AddOptionToString(sline,boardIndexString,',');
    }
    if (!window.confirm(iselected + "개의 선택된 정보를 삭제합니까?")) return false;
    const sendData = {mode:2,delitems: boardIndexString};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_delete_board_list`, sendData).then((res) => {
      console.log(res.data);
      if (res.data.retvalue === 1) {
        ReadFaqLists();
      } else {
        alert(res.data.message);
      }
    });    
  }

  return (
    <div className="main-box" style={{marginTop:"30px"}}>
      <div className="btn-right">
        <div><label htmlFor="tcount">검색건수</label>&nbsp;<span id="tcount">{varTotalCount}</span>&nbsp;건</div>&nbsp;&nbsp;&nbsp;
        <Link to={`/Admin/FaqDetail/0`} className="btn-danger">신규등록</Link>
        {varFaqLists?.length===0?null:<button onClick={(e)=>onDeleteFaqList(e)} className="btn line">삭제</button>}
      </div>
      <div className="scroll-table">
        <table className="list scroll delivery" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => {
              const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
              return (
                <tr key={key} {...restHeaderGroupProps}>
                  {headerGroup.headers.map((column,ii) => {
                    const { key, ...restColumn } = column.getHeaderProps({style:{width:ii===0?40:column.width}});
                    return (<th key={key} {...restColumn}>{column.render('Header')}</th>);
                  })}
                  <th style={{width:"90px"}}>상세</th>
                </tr>
              )
            })}
          </thead>
          <tbody {...getTableBodyProps()}>
            {varFaqLists?.length === 0? 
              <tr>
                <td colSpan={6}>등록된 FAQ가 없습니다.</td>
              </tr>
            :
              rows.map((row,i) => {
                prepareRow(row);
                const { key, ...restRowGroupProps } = row.getRowProps();
                return (
                  <tr key={key} {...restRowGroupProps}>
                    {row.cells.map((cell,j) => {
                      const { key, ...restCellProps } = cell.getCellProps();
                      return (<td key={key} {...restCellProps}>{cell.render('Cell')}</td>);
                    })}
                    <td>
                      <Link to={`/Admin/FaqDetail/${row.values.board_idx}`} style={{width:"70px"}} className="btn line black">상세</Link>
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </div>
    </div>
  )
}
export default FaqSearchResult;